import { ActionContext } from 'vuex'
import {
  initWebSocket,
  sendWSRequest,
  closeWebSocket,
  addOnMessageListenerOnce,
  addOnMessageListenerWithKey,
} from '@/lib/api/wsClient'
import sessionStrageUtils from '@/lib/sessionStrage/session-strage-utils'

type StateType = {
  token: string
  memoData: string
  userData: { id: string; name: string }
  connectedUsers: {
    staff_id: string
    staff_name: string
  }[]
}

const state: StateType = {
  token: '',
  memoData: '',
  userData: { id: '', name: '' },
  connectedUsers: [],
}

const mutations = {
  setToken(state: StateType, token: string) {
    state.token = token
  },
  setMemoData(state: StateType, memoData: string) {
    state.memoData = memoData
  },
  setUserData(state: StateType, userData: { id: string; name: string }) {
    state.userData = userData
  },
  setConnectedUsers(
    state: StateType,
    connectedUsers: StateType['connectedUsers']
  ) {
    state.connectedUsers = connectedUsers
  },
}

type RootState = {}
type MemoActionContext = ActionContext<StateType, RootState>

const actions = {
  async initWebSocket({ commit }: MemoActionContext, { id }: { id: string }) {
    await initWebSocket(id)
    addOnMessageListenerOnce('initWebSocket', msg => {
      if (msg.token) {
        commit('setToken', msg.token)
      }
      if (msg.memo) {
        commit('setMemoData', msg.memo.note)
        commit('setUserData', {
          id: msg.memo.child_id,
          name: msg.memo.child_name,
        })
      }
    })
  },

  // メモ情報の最初の取得
  async fetchMemoData({ commit }: MemoActionContext, { id }: { id: string }) {
    addOnMessageListenerWithKey('fetchMemoData', (msg: any) => {
      if (msg.memo) {
        commit('setMemoData', msg.memo.note)
      }
      if (msg.connected_users && msg.connected_users.length > 0) {
        commit('setConnectedUsers', msg.connected_users)
      }
    })

    const currentOffice = sessionStrageUtils.handleGetSessionStorage(
      'currentStaff'
    )
    const officeId = currentOffice?.office_id
    const staffId = currentOffice?.staff_id
    await sendWSRequest({
      action: 'get_memo',
      officeId,
      childId: id,
      staffId,
    })
  },

  // メモ情報の更新 (ユーザの入力をサーバに送る)
  async updateMemoData(
    { state }: MemoActionContext,
    { id, memoContent }: { id: string; memoContent: string }
  ) {
    const currentOffice = sessionStrageUtils.handleGetSessionStorage(
      'currentStaff'
    )
    const officeId = currentOffice?.office_id
    const staffId = currentOffice?.staff_id
    const token = state.token

    await sendWSRequest({
      action: 'update_memo',
      token,
      officeId,
      childId: id,
      staffId,
      memoContent,
    })
  },

  async closeMemo({ commit }: MemoActionContext) {
    closeWebSocket()
    commit('setToken', '')
    commit('setMemoData', '')
    commit('setUserData', { id: '', name: '' })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
